import React from "react";
import styles from "../../styles/pages/myaccount.module.scss";
import { SendOTP } from "../../api/myaccount";
import MUITextField from "../common/ui-components/input/MUITextField";
import { otpRequestSuccess } from "../../tracking/segment/loginPage";
import { getPageURL } from "../../utils/tracking";
import moment from 'moment'
import { secondsToHHMM } from "../../utils";
import ReCAPTCHA from "react-google-recaptcha";
import { getCachedRecaptchaToken, isRecaptchaReady } from "../../utils/recaptcha";
import Config from "../../config";
import Button from "../common/ui-components/input/Button";

const LogInStep = (props: any) => {
  const [error, setError] = React.useState<string>("");
  const [phone, setPhone] = React.useState<string>(props.phone);
  const [blockTime, setBlockTime] = React.useState<any>('');
  const [isCaptchaRequired, setIsCaptchaRequired] = React.useState<boolean>(false);
  const [isCaptchaVerified, setIsCaptchaVerified] = React.useState<boolean>(false);
  const [captchaV2Token, setCaptchaV2Token] = React.useState<string>("");
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const recaptchaV2Key = Config.RECAPTCHA_V2_SITE_KEY;

  const getCaptchaToken = async (): Promise<string> => {
    return getCachedRecaptchaToken("otp");
  };

  const sendOtp = async (phone, captchaToken: string, captchaTokenType: "v2" | "v3") => {
    if (!captchaToken) {
      setError("CAPTCHA not ready. Please refresh the page again.");
      setIsLoading(false);
      return;
    }
    SendOTP({
      application: "website",
      data: {
        phone: phone,
        type: "customer-login",
        template: "otp_customer_auth",
        captcha_token: captchaToken,
        captcha_token_type: captchaTokenType,
      },
    })
      .then((res: any) => {
        setIsLoading(false);
        props.setSessionCaptchaToken?.(captchaToken);
        setIsCaptchaRequired(false);
        setIsCaptchaVerified(false);
        setCaptchaV2Token("");
        props.updateCustomerDetails({
          phone: phone,
          exists: res.data.exists,
        });
        otpRequestSuccess({ phone: phone, ...getPageURL(), source: "Log in" });
        setError("");
        props.progressStep(2);
        if (document.querySelector(`input#otp`)) {
          const a: any = document.querySelector(`input#otp`);
          setTimeout(() => {
            a.focus();
          }, 300);
        }
      })
      .catch((err: any) => {
        setIsLoading(false);
        err.json().then((res:any) => {
          if(res.login_attempt_info){
            let blockTime = moment().add(res.remaining_seconds, 'seconds');
            let diff = blockTime.diff(moment(),'seconds')
            setBlockTime(blockTime)
            setError(`Your account has been blocked for next ${secondsToHHMM(diff)} due to multiple incorrect OTP attempts.`)
            let blockTimerInterval = setInterval(function () {
              diff = blockTime.diff(moment(),'seconds')
              setError(`Your account has been blocked for next ${secondsToHHMM(diff)} due to multiple incorrect OTP attempts.`)
              if(diff <= 0){
                clearInterval(blockTimerInterval)
                setBlockTime(null)
                setError('');
              }
              
            }, 1000);
          }
          else{
            const errorCodes = res?.error_code;
            console.log(errorCodes,"errorCodes", errorCodes.includes("recaptcha_verification_failed"), errorCodes.includes("additional_authentication_required"))
            const isAuthFailed = errorCodes.includes("recaptcha_verification_failed");
            const isAdditionalAuthRequired = errorCodes.includes("additional_authentication_required");
            if (isAuthFailed) {
              setError("Please refresh the page. If not, the page will refresh automatically in 10 seconds.");
              setTimeout(() => {
                window.location.reload();
              }, 10000);
              return;
            }
            if (isAdditionalAuthRequired) {
              setIsCaptchaRequired(true);
              setIsCaptchaVerified(false);
              setCaptchaV2Token("");
              setError("Please complete the CAPTCHA to continue.");
              return;
            }
            console.log(err);
            setError("Please enter a valid Phone Number");
          }
        })
        
      });
  }
  const validate = async () => {
    if (!phone) {
      setError("Required field");
    } else {
      if (phone.length != 10) {
        setError("Please enter a valid Phone Number");
      } else {
        setIsLoading(true);
        const captchaToken = captchaV2Token || await getCaptchaToken();
        const captchaTokenType = captchaV2Token ? "v2" : "v3";
        sendOtp(phone, captchaToken, captchaTokenType)
      }
    }
  };

  let onPhoneChange = (e: any) => {
    let phone = e.target.value.trim().replace(/\D/g, "");
    if (phone.length < 11) {
      setPhone(phone);
    }
  };

  React.useEffect(() => {
    if (props.customer.phone_prefilled && props.customer.phone) {
      setPhone(props.customer.phone);
      (async () => {
        const captchaToken = captchaV2Token || await getCaptchaToken();
        const captchaTokenType = captchaV2Token ? "v2" : "v3";
        sendOtp(props.customer.phone, captchaToken, captchaTokenType);
      })();
    }
  }, [])

  

  return (
    <div className={styles.input_parent}>
      <div className={styles.text_box}>
        <MUITextField
          className={styles.password}
          type="text"
          label="Mobile Number"
          onChange={(e) => {
            onPhoneChange(e);
          }}
          propsError={error}
          isRequired={true}
          value={phone}
          isAutoFocus={true}
          onKeyPress={(e) => {
            e.key === "Enter" && validate();
          }}
        />

      {isCaptchaRequired && recaptchaV2Key && (
        <div className={styles.recaptcha}>
          <ReCAPTCHA
            sitekey={recaptchaV2Key}
            enterprise={false}
            onChange={(token) => {
              setCaptchaV2Token(token || "");
              setIsCaptchaVerified(Boolean(token));
              setError("");
            }}
            onExpired={() => {
              setCaptchaV2Token("");
              setIsCaptchaVerified(false);
            }}
            onErrored={() => {
              setError("Verification failed to load. Please refresh the page and try again.");
            }}
          />
        </div>
      )}
      </div>

      <div className={`${styles.button} ${blockTime && blockTime > moment() && styles.disabled}`}>
            <Button
              disabled={ isLoading && 
                (blockTime && blockTime > moment()) ||
                (isCaptchaRequired && !isCaptchaVerified) ||
                (!isRecaptchaReady() && !captchaV2Token)
              }
              className={styles.cart_btn}
              text={'NEXT'}
              loading={isLoading}
              onClick={(e) => {
            if (blockTime && blockTime > moment()) {
              return;
            }
            if (isCaptchaRequired && !isCaptchaVerified) {
              console.log(isCaptchaRequired && !isCaptchaVerified,"isCaptchaRequired && !isCaptchaVerified")
              return;
            }
            if (!isRecaptchaReady() && !captchaV2Token) {
              setError("CAPTCHA not ready. Please refresh the page again.");
              return;
            }
            validate();
          }}
            />
      </div>
    </div>
  );
};

export default LogInStep;
